module.exports = __webpack_public_path__ + "assets/img/a19c-hn.svg";